var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.0293C11.4368 3.0293 10.8739 3.29174 10.5586 3.81641L1.76172 18.4512C1.11349 19.5292 1.94287 21 3.20117 21H20.7969C22.0548 21 22.8865 19.5292 22.2383 18.4512L13.4414 3.81641C13.1261 3.29174 12.5632 3.0293 12 3.0293ZM12 5.29883L20.2363 19H3.76367L12 5.29883ZM11 9V14H13V9H11ZM11 16V18H13V16H11Z",
    fill: "#D13D3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorNotification);
export default __webpack_public_path__ + "static/media/errorNotification.0654506530fa0a8f4500d42d89ae98e6.svg";
export { ForwardRef as ReactComponent };